// extracted by mini-css-extract-plugin
export default {"wrapper":"privacy_wrapper__v2j8m"};